import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class BillingErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Billing section error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-card border border-border p-8 bg-card text-center">
          <AlertTriangle size={32} className="mx-auto text-muted mb-3" />
          <h3 className="text-[16px] font-semibold text-primary mb-1">
            Billing Unavailable
          </h3>
          <p className="text-[13px] text-secondary">
            Unable to load billing information. Please try again later.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
